import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ResolvedPreviewHref } from "./MarketplaceItemPreviewCard.types";
import MarketplaceCopyListingButton from "./MarketplaceCopyListingButton";
import MarketplaceExternalOpenIcon from "./MarketplaceExternalOpenIcon";
interface MarketplaceOverlayActionButtonsProps {
  readonly href: string;
  readonly resolvedPreviewHref: ResolvedPreviewHref;
}
export default function MarketplaceOverlayActionButtons(t0) {
  const $ = _c(10);
  const {
    href,
    resolvedPreviewHref
  } = t0;
  const {
    href: resolvedHref,
    target,
    rel
  } = resolvedPreviewHref;
  let t1;
  if ($[0] !== href) {
    t1 = <MarketplaceCopyListingButton href={href} testId="marketplace-item-overlay-copy-button" className="tw-flex tw-size-8 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-transparent tw-text-white tw-backdrop-blur-md tw-transition-colors tw-duration-150" />;
    $[0] = href;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MarketplaceExternalOpenIcon className="tw-size-3.5 tw-flex-shrink-0" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== rel || $[4] !== resolvedHref || $[5] !== target) {
    t3 = <Link href={resolvedHref} target={target} rel={rel} prefetch={false} className="tw-flex tw-size-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-transparent tw-text-white tw-no-underline tw-backdrop-blur-md tw-transition-colors tw-duration-150" data-testid="marketplace-item-overlay-open-link" onClick={_temp} onMouseDown={_temp2} onTouchStart={_temp3}>{t2}</Link>;
    $[3] = rel;
    $[4] = resolvedHref;
    $[5] = target;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className="tw-absolute tw-right-3 tw-top-3 tw-z-10 tw-flex tw-flex-col tw-gap-2">{t1}{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp3(event_1) {
  return event_1.stopPropagation();
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp(event) {
  return event.stopPropagation();
}